import React from 'react';
import PropTypes from 'prop-types';
import utils from "@utils";
import { Link } from "react-router";
import TimeHoverTooltip from "../TimeHoverTooltip";


const NonRKPayInvoiceItemView = ({
	user,
	user: { TimeZoneId },
	item,
	nonRKPayInvoiceDetailHook
}) => {
	const { lang } = global;

	const {
		invoiceState,
		isAttachmentsVisible,
		isTimeCardNoteVisible,
		toggleLineFees,
		toggleAttachmentsModal,
		toggleTimeCardNotesModal,
		onClickViewJobActivityLogLineItem,
	} = nonRKPayInvoiceDetailHook;

	const { lineFeeToggler } = invoiceState;

	return (
		<div
			className="row line-item"
			key={`assignment_${item.JobAssignmentId}`}
		>
			<div className="col-md-1">
				<strong className="hidden-md hidden-lg">
					{lang.t("Job ID")}:{" "}
				</strong>
				<Link to={`/jobs/${item.JobEventId}`}>
					<span className="btn btn-link padding-md-left-0">
						{item.JobEventId}
					</span>
				</Link>
			</div>
			<div
				className="col-xs-12 col-md-2"
				title={item.JobEventTitle}
			>
				<strong className="hidden-md hidden-lg">
					{lang.t("Job Name")}:{" "}
				</strong>
				<span className="hidden-md hidden-lg">{`${item.JobEventTitle} (${item.JobEventId})`}</span>
				<strong className="hidden-xs hidden-sm">{`${item.JobEventTitle} (${item.JobEventId})`}</strong>
				<em className="hidden-md hidden-lg padding-left-4">
					<small>{item.JobTitle}</small>
				</em>
				<br className="hidden-xs hidden-sm" />
				<em className="hidden-xs hidden-sm">{item.JobTitle}</em>
			</div>

			<div className="col-xs-12 col-md-2 date-col">
				<div className="card-only v-align">
					<strong>
						{lang.t("Date")} &amp; {lang.t("Time")}:{" "}
					</strong>
					<span className="padding-right-4 padding-left-4">
						{
							utils.splitDateTimeComponents(
								item.JobStartTime,
								TimeZoneId,
								user.UserPreferences === "useMilitaryTime",
							).date
						}
					</span>
					<TimeHoverTooltip
						item={item}
						TimeZoneId={TimeZoneId}
						user={user}
					/>
				</div>
				<div className="hidden-xs hidden-sm">
					<p>
						{
							utils.splitDateTimeComponents(
								item.JobStartTime,
								TimeZoneId,
								user.UserPreferences === "useMilitaryTime",
							).date
						}
					</p>
					<TimeHoverTooltip
						item={item}
						TimeZoneId={TimeZoneId}
						user={user}
					/>
				</div>
			</div>

			<div className="col-xs-12 col-md-2">
				<div
					className="align-center-sm"
					title={item.OfficerName}
					key={`position_${item.JobAssignmentId}-${item.OfficerName}`}
				>
					<strong className="card-only">{lang.t("Officer")}: </strong>
					<span className="item-officer-name">
						{item.OfficerName}
					</span>
					<If condition={item.OfficerId}>
						<button
							type="button"
							className="btn btn-link padding-left-0"
							onClick={onClickViewJobActivityLogLineItem(item)}
						>
							<span className="truncate">
								{`#${item.PONumber ? item.PONumber : ""}`}
							</span>{" "}
							View Activity
						</button>
					</If>
					<If condition={isAttachmentsVisible(item)}>
						<button
							type="button"
							className="btn btn-link padding-left-0"
							onClick={() => toggleAttachmentsModal({ ...item })}
						>
							<i
								className="rkf rkf-Paperclip"
								aria-label="View Attachments"
							/>
						</button>
					</If>
					<If condition={isTimeCardNoteVisible(item)}>
						<button
							type="button"
							className="btn btn-link padding-left-0"
							onClick={() => toggleTimeCardNotesModal({ ...item })}
						>
							<i
								className="rkf rkf-clipboard"
								aria-label="View Timecard Notes"
							/>
						</button>
					</If>
				</div>
			</div>
			<div className="col-xs-12 col-md-1">
				<label
					className="card-only"
					htmlFor={`positionRate-${item.JobAssignmentId}`}
				>
					<strong>{`${lang.t("Rate")}`}: </strong>
				</label>
				<span className="hidden-md hidden-lg padding-left-5">
					{utils.currencyFormatter(item.Rate)}
				</span>
				<div className="hidden-xs hidden-sm">
					{utils.currencyFormatter(item.Rate)}
				</div>
			</div>
			<div className="col-xs-12 col-md-1">
				<label
					className="card-only"
					htmlFor={`positionHours-${item.JobAssignmentId}`}
				>
					<strong>{lang.t("Hours")}</strong>
				</label>
				<span className="hidden-md hidden-lg padding-left-5">
					{item.Hours}
				</span>
				<div className="hidden-xs hidden-sm">{item.Hours}</div>
			</div>
			<div className="col-xs-6 col-md-2">
				<strong className="card-only">Fees:&nbsp;</strong>
				<span
					className={
						item.Fees.some(fee => fee._totalModified === true)
							? "fee-changed"
							: ""
					}
				>
					{utils.currencyFormatter(item.FeeTotal)}
				</span>
				<button
					type="button"
					className="btn btn-link padding-top-0"
					onClick={() => toggleLineFees(item.JobAssignmentId)}
				>
					<i
						className={`rkf rkf-chevron-${lineFeeToggler[item.JobAssignmentId] ? "up" : "down"}`}
						aria-label="Toggle Line Item Fee"
					/>
				</button>
			</div>
			<div className="col-xs-6 col-md-1 hidden-md col-md-1 text-right">
				<strong className="card-only">Total:&nbsp;</strong>
				<strong>{utils.currencyFormatter(item.TotalAmount)}</strong>
			</div>
			<div className="col-md-1 visible-md text-right">
				<strong>{utils.currencyFormatter(item.TotalAmount)}</strong>
			</div>
			<div
				className={`col-xs-12 line-fees${lineFeeToggler[item.JobAssignmentId] ? "" : " hidden"}`}
			>
				<For
					each="fee"
					of={item.Fees}
					index="index"
				>
					<div
						className="row"
						key={`${item.JobAssignmentId}-fee_${fee.Id || index}`}
					>
						<div className="col-md-11 print-right text-right">
							<span>{fee.Name}</span>
							<span className="item-fee-total">
								{utils.currencyFormatter(fee.Total)}
							</span>
						</div>
					</div>
				</For>
			</div>
		</div>
	);
}

NonRKPayInvoiceItemView.propTypes = {
	user: PropTypes.object,
	item: PropTypes.object,
	nonRKPayInvoiceDetailHook: PropTypes.object.isRequired,
};

NonRKPayInvoiceItemView.defaultProps = {
	user: {},
	item: {}
};

export default NonRKPayInvoiceItemView;
